import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { enqueueSnackbar } from 'notistack';
import StudentSubjectMappingForm from './StudentSubjectMappingForm';
import Button from '../../components/Button/Button';
import { getClassWiseStudentList } from '../../services/StudentService';
import { getClassWiseSubjects } from '../../services/SubjectServices';
import { createStudentSubjectMapping, getStudentSubjectMappingList, updateStudentSubjectMapping } from '../../services/StudentSubjectMappingService';

const StudentSubjectMappingManage = () => {
  const navigate = useNavigate();
  const [program_id, setProgramId] = useState("");
  const [student_ids, setStudentIds] = useState([]);
  const [SubjectList, setSubjectList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [subject_ids, setSubjectIds] = useState([]);
  const [student_loader, setStudentLoader] = useState(false);
  const [subject_loader, setSubjectLoader] = useState(false);
  const pathname = window.location.pathname;

  const getSubjectList = async (programId) => {
    try {
      setSubjectLoader(true);
      const res = await getClassWiseSubjects(programId);
      const subjectData = res.data.data;
      setSubjectList(subjectData);
    } catch (error) {
    }
    finally {
      setSubjectLoader(false);
    }
  };

  const getStudentList = async (program_id) => {
    try {
      setStudentList([]);
      setStudentLoader(true);
      const response = await getClassWiseStudentList(program_id);
      if (response.status === 200) {
        const studentList = response.data.data;
        setStudentList(studentList);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setStudentLoader(false);
    }
  };

  const fetchData = async (subject_id) => {
    let session_id = localStorage.getItem("session_id");
    try {
      setLoader(true);
      setStudentIds([]);
      let response = await getStudentSubjectMappingList(session_id, program_id, subject_id);

      if (response.status === 200) {
        let data = response.data.data;
        if (pathname === "/student/subject/mapping/create")
          enqueueSnackbar("Student already mapped. Please update the data", { variant: 'warning' });
        navigate(`/student/subject/mapping/update`);
        setStudentIds(data.map((student) => student.id.toString()));
      }
      else if (response.status === 404) {
        setStudentIds([]);
      }
    }
    catch (error) {
      setStudentIds([]);
    }
    finally {
      setLoader(false);
    }
  }

  const studentChangeHandler = (event) => {
    const { value, checked } = event.target;
    const student_id = value;
    if (checked) {
      setStudentIds([...student_ids, student_id]);
    } else {
      const updatedStudentIds = student_ids.filter((id) => id !== student_id);
      setStudentIds(updatedStudentIds);
    }
  };

  const selectAllStudent = (event) => {
    setStudentIds(event.target.checked ? studentList.map((student) => student.id.toString()) : []);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "program_id") {
      setProgramId(value);
      setStudentIds([]);
      getStudentList(value);
      getSubjectList(value);
    }
  };

  const allSubjectChangeHandler = (event) => {
    if (event.target.checked) {
      setSubjectIds(SubjectList.map((subject) => subject.id.toString()));
    } else {
      setSubjectIds([]);
    }
  };

  const subjectChangeHandler = (event) => {
    const { value, checked } = event.target;
    const subject_id = value;
    if (checked) {
      if (!subject_ids.includes(subject_id)) {
        setSubjectIds([...subject_ids, subject_id]);
        fetchData(subject_id);
      }
    } else {
      setSubjectIds(subject_ids.filter((id) => id !== subject_id));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const session_id = localStorage.getItem("session_id");
    const data = { session_id, program_id, student_ids, subject_ids };
    try {
      let pathname = window.location.pathname;
      setLoader(true);
      if (pathname === "/student/subject/mapping/update") {
        const response = await updateStudentSubjectMapping(data);
        setLoader(false);
        if (response.status === 200) {
          let msg = response.data.message.success;
          enqueueSnackbar(msg, { variant: 'success' });
          navigate("/student/subject/mapping/list");
        }
        else {
          enqueueSnackbar(response.data.message.error, { variant: 'error' });
        }
      }
      else {
        const response = await createStudentSubjectMapping(data);
        setLoader(false);
        if (response.status === 201) {
          enqueueSnackbar(response.data.message.success, { variant: 'success' });
          navigate("/student/subject/mapping/list");
        }
      }
    }
    catch (error) {
      console.error(error);
    }
  };

  const back = () => {
    navigate("/student/subject/mapping/list");
  };

  return (
    <div className='card'>
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div className="main-title-page page-title d-flex align-items-center">
            <div className="mx-2">
            </div>
            <span>
              {pathname
                === "/student/subject/mapping/update" ?
                "Update Student Subject Mapping" : "Student Subject Mapping"
              }
            </span>
          </div>
          <Button variant="secondary" className='mx-2'
            onClick={back}>
            Back</Button>
        </div>
      </div>
      {loader ? <Loader /> : null}
      <div className="card-body">
        <StudentSubjectMappingForm
          student_loader={student_loader}
          subject_loader={subject_loader}
          program_id={program_id}
          student_ids={student_ids}
          studentList={studentList}
          subjectData={SubjectList}
          submitHandler={handleSubmit}
          changeHandler={handleChange}
          selectAllStudent={selectAllStudent}
          studentChangeHandler={studentChangeHandler}
          subject_ids={subject_ids}
          allSubjectChangeHandler={allSubjectChangeHandler}
          subjectChangeHandler={subjectChangeHandler}
        />
      </div>
    </div>
  );
};

export default StudentSubjectMappingManage;


